import config from 'config';

const provider = config.enableCusomterTokenManagement
  ? require('./CustomerTokenProviderSdk')
  : require('./CustomerTokenProviderLegacy');

export const CustomerTokenProvider = provider.CustomerTokenProvider;
